<template>
  <div v-if="status !== 'initialized' && status !== 'idle'" class="diet-detail-save">
    <template v-if="status === 'inProgress' || status === 'pending'">
      <BaseLoader class="base-loader--size-12" variant="outline" />
      Zapisuję
      {{ type === 'diet' ? 'dietę' : 'potrawę' }}
    </template>
    <template v-else-if="status === 'success'">
      <BaseIcon type="success" size="14" name="check_circle" variant="outline" />
      Zapisano
      {{ type === 'diet' ? 'dietę' : 'potrawę' }}
    </template>
    <template v-else>
      <BaseIcon size="14" type="warning" variant="outline" name="error" />
      <span class="not-saved">Nie zapisano {{ type === 'diet' ? 'diety' : 'potrawy' }}</span>
    </template>
  </div>
</template>

<script lang="ts" setup>
  import type { PropType } from 'vue'

  import BaseIcon from '@/components/BaseIcon.vue'
  import BaseLoader from '@/components/BaseLoader.vue'

  import type { SaveStatus } from '@/store/types'

  defineProps({
    status: {
      required: true,
      type: String as PropType<SaveStatus>,
    },
    type: {
      default: 'success',
      type: String as PropType<'diet' | 'dish'>,
    },
  })
</script>

<style scoped>
  .diet-detail-save::before {
    flex: auto;
    content: "";
  }

  .diet-detail-save {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: auto;
    font-size: 10px;
    color: var(--color-tertiary-text);
    white-space: nowrap;
  }

  .diet-detail-save .not-saved {
    font-family: Montserrat-SemiBold;
    color: var(--color-destructive-100);
  }

  .diet-detail-save :deep(.base-loader),
  .diet-detail-save :deep(.base-icon) {
    margin-right: 4px;
  }

  .diet-detail-save :deep(.base-loader) .base-loader__circle::before {
    background-color: var(--color-warning-100);
  }
</style>
